
import { defineComponent } from 'vue'

import { centsToDollars } from '~/utils/billing'

export default defineComponent({
  name: 'V2CheckoutPlanSummary',
  props: {
    planName: {
      type: String,
      required: true
    },
    billingInterval: {
      type: String as () => 'monthly' | 'yearly',
      required: true
    },
    seats: {
      type: Number,
      required: true
    },
    additionalTargetQuantity: {
      type: Number,
      required: true
    },
    aiCredits: {
      type: Number,
      required: true
    },
    formattedTotal: {
      type: String,
      default: ''
    },
    nextBillingDate: {
      type: String,
      default: ''
    },
    calculating: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    aiReviewLabel(): string {
      const dollars = centsToDollars(this.aiCredits)
      const period = this.billingInterval === 'yearly' ? 'year' : 'month'
      return `$${dollars} per ${period} team credit included`
    }
  },
  methods: {
    toggleInterval() {
      this.$emit(
        'update:billing-interval',
        this.billingInterval === 'monthly' ? 'yearly' : 'monthly'
      )
    }
  }
})
